/**
 * Rollen und Rechte.
 *
 * Drei feste Rollen statt eines Berechtigungsrasters — siehe Konzept Abschnitt 2.
 * Diese Datei ist die einzige Wahrheit: Die API prüft damit, das Frontend blendet
 * damit aus, der MCP-Server begrenzt damit seine Werkzeuge.
 */

export const ROLES = ['admin', 'manager', 'viewer'] as const;
export type Role = (typeof ROLES)[number];

export const ROLE_LABELS: Record<Role, string> = {
  admin: 'Yagemi Admin',
  manager: 'Khadi Manager',
  viewer: 'Khadi Leser',
};

/** Einzelne Fähigkeiten, wie sie in den Route-Hooks geprüft werden. */
export const PERMISSIONS = [
  'asset.read',
  'asset.write',
  'asset.move',
  'asset.archive',
  'asset.delete',
  'employee.read',
  'employee.write',
  'stammdaten.read',
  'stammdaten.write',
  'inventory.read',
  'inventory.write',
  'label.print',
  'export.read',
  'cost.read',
  'audit.read',
  'admin.manage',
] as const;
export type Permission = (typeof PERMISSIONS)[number];

const VIEWER: Permission[] = [
  'asset.read',
  'employee.read',
  'stammdaten.read',
  'inventory.read',
  'export.read',
];

const MANAGER: Permission[] = [
  ...VIEWER,
  'asset.write',
  'asset.move',
  'asset.archive',
  'employee.write',
  'stammdaten.write',
  'inventory.write',
  'label.print',
  'cost.read',
];

const ADMIN: Permission[] = [...MANAGER, 'asset.delete', 'audit.read', 'admin.manage'];

export const ROLE_PERMISSIONS: Record<Role, readonly Permission[]> = {
  viewer: VIEWER,
  manager: MANAGER,
  admin: ADMIN,
};

export function can(role: Role, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role].includes(permission);
}

/** Für Token-Scopes: engt die Rechte einer Rolle zusätzlich ein. */
export function canWithScopes(
  role: Role,
  permission: Permission,
  scopes?: readonly string[] | null,
): boolean {
  if (!can(role, permission)) return false;
  if (!scopes || scopes.length === 0) return true;
  return scopes.includes('*') || scopes.includes(permission);
}
